/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

"use strict";

require("./bootstrap");
require("./vendor/jwplayer");
require("./vendor/jwpsrv");
require("./vendor/dai");
require("./vendor/freewheel");
require("./vendor/gapro");
require("./vendor/jwplayer.core.controls.html5");
require("./login");
require("./upload");
require("./personal");
require("./navbar");
require("./modal");
require("./dropify");
require("./input-tag");
require("./video");
require("./validate");
require("./notification");
require("./page-static");
require("./custom");
require("./jwplayer");
require("./image-picker");
require("./comment");
require("./channel");
require("./category");
require("./manager-content");
require("./manager");
require("./swiper");
require("./playlist");
require("./history");
require("./favorite");
require("./livestream");
require("./search");
require("./cooperation");

// new code
require("./music");
require("./music-playlist");
require("./layer");
require("jquery.cookie");
// require('./firebase');

require("./music-player");
require("./player-song");
